import api from "./api";

interface ProjectItem {
  id: number;
  name: string;
  code: string;
  leader: string | null;
  department: string | null;
  progress: number;
  status: string;
  start_date: string | null;
  description: string | null;
  created_at: string;
  updated_at: string;
}

async function listProjects(search?: string): Promise<ProjectItem[]> {
  const params = search ? `?search=${encodeURIComponent(search)}` : "";
  return api.get<ProjectItem[]>(`/projects${params}`);
}

async function createProject(data: {
  name: string;
  code: string;
  leader?: string;
  department?: string;
  progress?: number;
  status?: string;
  start_date?: string;
  description?: string;
}): Promise<{ id: number; name: string }> {
  return api.post("/projects", data);
}

async function updateProject(
  id: number,
  data: {
    name?: string;
    code?: string;
    leader?: string;
    department?: string;
    progress?: number;
    status?: string;
    start_date?: string;
    description?: string;
  }
): Promise<{ message: string; id: number }> {
  return api.put(`/projects/${id}`, data);
}

async function deleteProject(id: number): Promise<{ message: string }> {
  return api.delete(`/projects/${id}`);
}

export interface ProjectCountStats {
  total: number;
  in_progress: number;
  completed: number;
  paused: number;
}

async function countProjects(): Promise<ProjectCountStats> {
  return api.get<ProjectCountStats>("/projects/count");
}

export type { ProjectItem };
export { listProjects, createProject, updateProject, deleteProject, countProjects };
